/**
 * Component: Albaran
 * Package: Albaran
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\albaran\Albaran.js
 *
 * Requisito funcional: RQ10-007
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una tabla que permite listar los albaranes de venta almacenados.
 */

import React, { Component } from 'react'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import ListadoPage from '../../containers/page/ListadoPage'
import FiltrosAlbaranPage from '../../containers/albaran/FiltrosAlbaranPage'
import ModalAlbaranPage from '../../containers/albaran/ModalAlbaranPage'
import {estadoAlbaran as estadoAlbaranConstants} from '../../constants/albaran'
import { date_parser, dateTimeZones } from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

class Albaran extends Component {
  componentDidMount () {
    document.title = this.props.t('MENU.PEDIDO.ALBARANES_VENTA') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
    let fechaActual = date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora)
    this.props.actions.fetchAlbaranes({desde: fechaActual, 'seleccionar-todo': false})
  }

  render () {
    const {
      list = [], checkedFiltrosAlbaran, t, numeroRegistrosPorPagina, paginaActual,
      actions: {abrirDetallesAlbaran, duplicarDatosModalAlbaran, onDeleteAlbaran, imprimirAlbaran}
    } = this.props

    const tKey = 'ALBARANES.'
    const idElemento = 'idAlbaran'
    const table = {
      id: 'albaranTable',
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ALBARANES] > 1),
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => abrirDetallesAlbaran(row.idAlbaran),
      mostrarDuplicar: false,
      duplicar: (row) => duplicarDatosModalAlbaran(row.idAlbaran),
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.ALBARANES] > 1),
      onDelete: (row) => onDeleteAlbaran(row.idAlbaran),
      mostrarAlbaran:true,
      mostrarImprimirAlbaran:true,
      onImprimirAlbaran:(row) => imprimirAlbaran(row.idAlbaran),
      mostrarCambioEstado: false,
      columns: [
        {id: 'numeroAlbaran', name: t(tKey + 'COLUMNS.NUM_ALBARAN')},
        {id: 'estado', name: t(tKey + 'COLUMNS.ESTADO'), stilyzer: (row) => {
          switch(row.idEstado) {
            case estadoAlbaranConstants["BORRADOR"]:
              return <span className='albaran-estado-borrador'>{t('COMUN.ESTADO_ALBARAN.BORRADOR')}</span>
            case estadoAlbaranConstants["CANCELADO"]:
              return <span className='albaran-estado-cancelado'>{t('COMUN.ESTADO_ALBARAN.CANDELADO')}</span>
            case estadoAlbaranConstants["REALIZADO"]:
              return <span className='albaran-estado-realizado'>{t('COMUN.ESTADO_ALBARAN.REALIZADO')}</span>
            default:
              console.log('unhandler estado albaran: ', row.idEstado)
          }
        }},
        {id: 'razonSocialCliente', name: t(tKey + 'COLUMNS.CLIENTE')},
        {id: 'nombreDireccion', name: t('PEDIDOS.CLIENTE.MODAL_DIRECCIONES.GRANJA')},
        {id: 'nombreRuta', name: t(tKey + 'COLUMNS.RUTA')},
        {id: 'fechaCreacion', name: t(tKey + 'COLUMNS.FECHA'), type: 'fecha'},
        {id: 'numeroDosis', name: t(tKey + 'COLUMNS.NUMERO_DOSIS'), type: 'numero', numDecimales: 0},
        {id: 'tiposDosis', name: t(tKey + 'COLUMNS.TIPO_DOSIS')},
        {id: 'observaciones', name: t(tKey + 'COLUMNS.OBSERVACIONES')}
      ],
      rows:list.albaranes && Object.keys(list.albaranes).length > 0 ? list.albaranes : [],
      filtros: <FiltrosAlbaranPage idElemento={idElemento} />,
      leyenda: [
        {name: t(tKey + 'LEYENDA.BORRADOR'), color: '#aacfdc'},
        {name: t(tKey + 'LEYENDA.CANDELADO'), color: '#e59f93'},
        {name: t(tKey + 'LEYENDA.REALIZADO'), color: '#c0d2a1'}
      ],
      initialValues: {},
      showModal: this.props.showModalAlbaran
    }
    table.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          table.initialValues['check' + row[idElemento]] = checkedFiltrosAlbaran
        }
      }
    )

    const tableTotalesAlbaranes = {
      id: 'albaranesTotalesTable',
      multiHeader: false,
      hasCheckbox: false,
      hasOptions: false,
      mostrarModificar: false,
      paginarConScroll: true,
      hasPagination: false,
      columns: [
        {id: 'nombreRaza', name: t(tKey + 'RAZA')},
        {id: 'nombreTipoDosis', name: t(tKey + 'TIPO_DOSIS')},
        {id: 'totalDosis', name: t(tKey + 'TOTAL_DOSIS')}
      ],
      rows: list.totales && Object.keys(list.totales).length > 0 ? list.totales : [],
      initialValues: {}
    }

    return (
      <div>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ModalAlbaranPage/>
        <ListadoPage t_key={tKey} table={table}>
        </ListadoPage>
        <hr/>
        <p><b>{t(tKey + 'RESUMEN_ALBARANES')}</b></p>
        <ListadoPage t_key={tKey} noTitle={true} table={tableTotalesAlbaranes}>
        </ListadoPage>
      </div>
    )
  }
}

export default Albaran